import React from 'react'
import OutlineInput from '@mui/material/OutlinedInput'
import InputLabel from '@mui/material/InputLabel'
import FormControl from '@mui/material/FormControl'
import FormHelperText from '@mui/material/FormHelperText'
import {pickAttributes} from '../helpers/utils'
import TextField from '@mui/material/TextField';

export default function TextInput(props) {

  const errorId = `${props.id}-error-text`

  return (
    <FormControl {...pickAttributes(props, 'control')} >
      <TextField
        id={props.id}
        aria-describedby={errorId}
        value={props.value}
        {...pickAttributes(props, 'input')}
        label={props.caption}
      />
      <FormHelperText id={errorId} {...pickAttributes(props, 'error')}>{props.errorMessage}</FormHelperText>
    </FormControl>
  )
}
